import { useEffect, useState } from "react";

import ProgressChart from "./ProgressChart";
import { Task, Reward } from "util/typesAlt";
import TaskCard from "components/common/TaskCard";

const listAfter = (a: Task, b: Task): number => {
  const aTimestamp = a.about?.redeemedDatetime
    ? a.about.redeemedDatetime
    : a.feedback?.datetime;
  const bTimestamp = b.about?.redeemedDatetime
    ? b.about.redeemedDatetime
    : b.feedback?.datetime;

  if (aTimestamp === undefined) {
    return 1;
  }
  if (bTimestamp === undefined) {
    return -1;
  }
  return aTimestamp < bTimestamp ? 1 : -1;
};

const HomePage = ({
  rewards,
  tasks,
  points,
  disableRedact = false,
}: {
  rewards: Reward[] | null;
  tasks: Task[] | null;
  points: number | null;
  disableRedact?: boolean;
}) => {
  const [rewardIndex, setRewardIndex] = useState<number | null>(null);

  const activeRewards = rewards?.filter((reward) => !reward.exclude) || null;

  const selectedReward =
    activeRewards !== null && rewardIndex !== null
      ? activeRewards[rewardIndex]
      : null;

  const setRewardIndexSynced = (newIndex: number) => {
    setRewardIndex(newIndex);
    localStorage.setItem("rewardIndex", newIndex.toString());
  };

  useEffect(() => {
    if (activeRewards === null) {
      setRewardIndex(null);
      return;
    }
    if (activeRewards.length > 0) {
      let savedIndex = localStorage.getItem("rewardIndex");
      if (savedIndex !== null && parseInt(savedIndex) < activeRewards.length) {
        setRewardIndex(parseInt(savedIndex));
        return;
      }
      setRewardIndexSynced(activeRewards.length - 1);
    }
  }, [activeRewards]);

  return (
    <div>
      <div className="flex pt-6 px-3">
        <div className="flex-1">
          {points !== null && selectedReward?.points !== undefined && (
            <ProgressChart progress={points} goal={selectedReward.points} />
          )}
        </div>
        {activeRewards !== null && (
          <div className="flex-1 border border-gray-700 rounded pt-2">
            {activeRewards.map((reward, i) => (
              <div
                key={i}
                className={`px-2 select-none ${
                  rewardIndex === i
                    ? "bg-blue-500 text-gray-950"
                    : "text-gray-600"
                }`}
                onClick={() => setRewardIndexSynced(i)}
              >
                {reward.title}
              </div>
            ))}
          </div>
        )}
      </div>
      <>
        {tasks !== null && (
          <div className="p-3">
            {tasks
              .filter((task) => !task.about?.exclude)
              .sort(listAfter)
              .map((task, i) => (
                <div key={i} className="mt-4">
                  <TaskCard task={task} disableRedact={disableRedact} />
                </div>
              ))}
          </div>
        )}
      </>
    </div>
  );
};

export default HomePage;
